import config from "@/lib/config";
import Cookies from "@/lib/cookies";
export default class ChatGuideLineAgreement {
  constructor(req, res) {
    this.req = req;
    this.res = res;
    this.cookies = new Cookies(req, res);
  }
  get cookieName() {
    return config.chat.guidelineAgreementCookieName;
  }
  getCookie() {
    const value = this.cookies.get(this.cookieName);
    if (typeof value === "undefined" || value === null) return null;
    return value;
  }
  async setCookie(value) {
    return this.cookies.set([{
      name: this.cookieName,
      value: value,
      options: {}
    }]);
  }
  async delete() {
    this.cookies.remove([this.cookieName]);
  }
}